import React from 'react';
import { Settings } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-gray-900 text-white py-8 px-4" data-id="element-76">
      <div className="max-w-4xl mx-auto text-center" data-id="element-77">
        <div className="flex items-center justify-center gap-3 mb-4" data-id="element-78">
          <Settings className="w-6 h-6 text-teal-400" data-id="element-79" />
          <div data-id="element-80">
            <p className="font-semibold" data-id="element-81">Soporte</p>
            <a href="mailto:EbookDreamShop@gmail.com" className="text-teal-400 hover:text-teal-300 transition-colors" data-id="element-82">
              EbookDreamShop@gmail.com
            </a>
          </div>
        </div>
        <p className="text-sm text-gray-400" data-id="element-83">
          © 2026 Megapack Acompañante Pedagógico. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}